<div class="container">
    <app-header class="header"></app-header>
    <div class="content-cookies">
        <h2 class="tittle">Política de cookies</h2>
        <p>Esta Política de Cookies es parte integrante del <a (click)="goToUrl('terms-conditions')">Aviso Legal</a> y
            la <a (click)="goToUrl('privacy-polity')"> Política
                de
                Privacidad</a> de
            la página web www.akana.es (en adelante, el “Sitio Web” o la “Página Web”).</p>

        <p>Para facilitar su navegación por el Sitio Web, Open Bank, S.A., (en adelante, “Open Bank”) 
            te informa de que utiliza dispositivos de almacenamiento y recuperación de datos: cookies,
            píxeles publicitarios o tecnologías con funcionalidades similares (en adelante, conjuntamente, “Cookies”).
        </p>

        <p>En este sentido y con el objetivo de garantizarte toda la información necesaria para la correcta navegación,
            Open Bank pone a tu disposición la siguiente información sobre qué son las Cookies, qué tipología
            existen en el Sitio Web y cómo es posible configurarlas o deshabilitarlas. </p><br>

        <h2>CONCEPTO DE COOKIES</h2>

        <p>Las cookies, los píxeles publicitarios o las tecnologías similares son considerados instrumentos web que
            permiten almacenar y recuperar información de los Usuarios con el propósito de ofrecerles una mejor
            experiencia en el uso y navegación en los sitios web que viste el Usuario. </p>

        <p>En este sentido, las Cookies cumplen diferentes funcionalidades dependiendo de su naturaleza y la forma en la
            que se implementan en el Sitio Web. </p>

        <p>Con base en lo anterior, se procederá a explicar de forma pormenorizada las Cookies utilizados en el Sitio
            Web:
        </p><br>

        <h3>Cookie</h3>

        <p>Una cookie puede definirse como un pequeño archivo de texto o dispositivo de uso generalizado que se descarga
            en el equipo terminal del Usuario cuando navega por las páginas web con la finalidad de almacenar datos que
            podrán ser actualizados y recuperados por la entidad responsable de su instalación para mejorar la
            navegación y la experiencia de Usuario. Actualmente, todas las páginas web, independientemente del servicio
            que presten, utilizan Cookies, es decir, guardan una información mínima de la utilización realizada por el
            Usuario en la Página Web.</p><br>

        <h3>Píxeles publicitarios y tecnologías similares</h3>

        <p>Los píxeles publicitarios (también conocidos como balizas web o web bugs) son Cookies que son introducidos en
            el Sitio Web, normalmente, mediante la inserción de un pequeño fragmento de código fuente que permiten al
            propio Sitio Web transferir y/o recopilar información por medio de una solicitud al servidor vinculado con
            este píxel publicitario. La finalidad de este instrumento es variada, destacando la obtención de información
            relativa a la efectividad de las campañas de publicidad, tráfico generado en el Sitio Web, personalización
            de los anuncios y su contenido.</p><br>

        <h2>TIPO DE COOKIES QUE SE UTILIZAN EN LA WEB</h2>

        <h2>1. Tipología de las Cookies de información que utiliza el Sitio Web</h2>

        <p>Open Bank utiliza diferentes Cookies, tanto propias como de terceros. En este sentido, si estos
            dispositivos se almacenan en el ordenador del Usuario durante un tiempo determinado, pueden considerarse de
            sesión (si caducan cuando abandona el Sitio Web) o persistentes (si la caducidad de los mismos dura más
            tiempo).
        </p>

        <p>Las Cookies que pueden ser utilizadas en el Sitio Web son: </p><br>

        <h3>Técnicas.</h3>

        <p>Son aquellas Cookies estrictamente necesarios para la navegación por el Sitio Web, pues facilitan al Usuario
            la utilización de sus prestaciones o herramientas como, por ejemplo, identificar la sesión, acceder a partes
            de acceso restringido, recordar los elementos que integran un pedido, realizar el proceso de compra de un
            pedido, entre otros. Sin éstos, las funciones mencionadas quedarían inhabilitadas, siendo muy complicado o
            imposible navegar por el Sitio Web.</p>

        <p>Estas cookies no pueden ser rechazadas.</p>

        <p>Su instalación se efectúa mientras dure la sesión y, finalizada esta, durante un periodo máximo de 6 meses.
        </p>
        <br>

        <h3>De funcionalidad</h3>

        <p>Son aquellas cookies que permiten recordar información, incluso personal, para que el Usuario acceda al
            servicio con determinadas características que pueden diferenciar su experiencia de la de otros Usuarios,
            como, por ejemplo, el idioma, el número de resultados a mostrar cuando el Usuario realiza una búsqueda, el
            aspecto o contenido del servicio en función del tipo de navegador a través del cual el Usuario accede al
            servicio o de la región desde la que accede al servicio, etc. </p>

        <p>Estas cookies únicamente se instalarán en tu dispositivo en caso de que así lo autorice. </p>

        <p>Su instalación se efectúa mientras dure la sesión y, finalizada esta, durante un periodo máximo de 2 años.
        </p>
        <br>

        <h3>Cookies de rendimiento.</h3>

        <p>Son aquellas Cookies que permiten al responsable de las mismas, el seguimiento y análisis del comportamiento
            de los Usuarios de los Sitios Web a los que están vinculadas. La información recogida mediante este tipo de
            cookies se utiliza en la medición de la actividad del Sitio Web y para la elaboración de perfiles de
            navegación de los Usuarios, con el fin de introducir mejoras en función del análisis de los datos de uso que
            hacen los Usuarios del servicio.</p>

        <p>Entre otras finalidades, estas cookies nos permiten contabilizar las visitas y el origen de las mismas, para
            evaluar el rendimiento de nuestro sitio y mejorarlo, por ejemplo, identificando qué partes del sitio web son
            menos visitas o cómo navegan los usuarios por ella. </p>

        <p>La instalación de este tipo de cookies implica la intervención de Google, INC (entidad ubicada en EEUU). En
            todo caso, la información recabada se recopila de forma agregada y, por tanto, no se trata de forma
            individualizada. Puede obtener más información sobre cómo Google respeta su privacidad en el siguiente
            enlace: <a href="https://policies.google.com/privacy?hl=es"
                target="_blank">https://policies.google.com/privacy?hl=es</a>.
        </p>

        <p>Si no se autoriza la instalación de cookies, no se identificarán errores en el sitio web producidos durante
            la visita al mismo. </p>

        <p>Su instalación se efectúa mientras dure la sesión y, finalizada esta, durante un periodo máximo de 2 años.
        </p>

        <p>Si no se autoriza la instalación de cookies, no se identificarán errores en el sitio web producidos durante
            la visita al mismo. </p>
        <br>

        <h2>CONFIGURACIÓN DE COOKIES</h2>

        <h3>2. Sistema de configuración para la aceptación o rechazo de las cookies</h3>

        <p>Si pulsas el botón “Aceptar” del Aviso de Cookies se considerará que consientes de forma expresa la
            instalación de todas las cookies. </p>

        <p>En todo caso, podrás gestionar las cookies, es decir, rechazarlas por cada categoría o todas en su conjunto,
            a través del <a (click)="OptanonWrapper()">Configurador de Cookies</a>. Para ello, deberás pulsar
            en “Configurar cookies”,
            donde visualizarás todas las cookies desactivadas, por lo que si no aceptas su instalación, bastará con
            pulsar en “Confirmar selección”. Si deseas aceptar alguna de ellas, debes pulsar sobre su botón para
            activarlas y a continuación pulsar en “Configurar selección”. </p>

        <p>Por favor, ten en cuenta que en caso de que revoques el consentimiento desde el Configurador es posible que
            algunos navegadores visualices las cookies, si bien éstas dejarán de recabar información desde el momento en
            que hayas rechazado su uso. </p>

        <p>El mero acceso a esta Política, sin haber realizado una acción previa, no da lugar a una aceptación de las
            mismas.</p><br>

        <h2>CONFIGURACIÓN DEL NAVEGADOR</h2>

        <h3>3. Procedimiento de oposición a la instalación de las Cookies</h3>

        <p>La mayoría de ordenadores aceptan la utilización de Cookies de forma automática. Sin embargo, el Usuario
            tiene la posibilidad de decidir si los mantiene habilitadas o no en su ordenador. Algunas Cookies no pueden
            ser completamente gestionadas por medio del navegador, debiendo configurar estos dispositivos contactando
            directamente con el proveedor del mismo (por ejemplo, aquellas instaladas en su dispositivo móvil, debe ser
            deshabilitada desde el apartado relativo al ID del dispositivo). </p>

        <p>Con todo ello, incluso habiendo desactivado toda clase de Cookies, el navegador web recoge determinada
            información esencial para el funcionamiento básico del Sitio Web. </p>

        <p>El Usuario que quiera deshabilitar las Cookies puede hacerlo desde la sección de preferencias de su navegador
            de Internet. Dependiendo del navegador deberá de seguir determinados pasos para modificar la configuración
            de las Cookies en su ordenador: </p>
        <ul>
            <li>Chrome</li>
            <li>Safari</li>
            <li>Firefox</li>
            <li>Internet Explorer</li>
        </ul>
        <p>
            Todos los datos de carácter personal recopilados por parte de Open Bank por medio de las Cookies
            explicados en el presente documento se obtienen mediante la notificación y el consentimiento de los propios
            Usuarios.
        </p>

        <p>En este sentido, Open Bank quiere ser completamente transparente y claro con el objetivo de ofrecer
            a sus Usuarios la máxima información posible y los instrumentos necesarios para que se puedan desactivar las
            Cookies de la manera expuesta. </p>

        <p>SSi desea realizar alguna pregunta sobre la Política de Cookies del Sitio Web, se puede poner en contacto con
            el Titular a través de la siguiente dirección scprotecciondedatos&#64;santanderconsumer.com indicando en el
            asunto “Política de Cookies”. </p><br>

        <h3>Datos adicionales y listado de cookies tecnicas: </h3>
        <p id="ot-sdk-cookie-policy"></p>
    </div>
    <app-footer class="footer" [colorItems]="'#ffffff'" [classSpecial]="true"></app-footer>
</div>